import { Middleware } from "@nuxt/types";
import Cookie from "js-cookie";

import { getBaseURLDashboard } from "./__hooks/base-url-dashboard.hook";
import { getCheckRestriction } from "./__hooks/check-restriction.hook";
import NOT_LOGGED_IN_PAGES from "./redirect.constants";

import { TIMEOUT_REDIRECT } from "@/shared/constants/timeout.constant";
import { MOBILE_VIEWPORT } from "@/shared/constants/ui.constant";

const redirect: Middleware = async (context) => {
  const { store, route, from, app, next } = context;

  function toPath(path: string) {
    // avoid error duplicate navigation
    if (path !== from.path && next) {
      next({ path, replace: true });
    }
  }

  (async function (): Promise<void> {
    const getBaseUrlMainDashboard = getBaseURLDashboard(context);
    // ED-2721: Tweak the token always get from the cookie.
    // const userToken = store.getters["auth/getUserToken"];
    const userToken = Cookie.get("t");
    if (userToken && route.name && !NOT_LOGGED_IN_PAGES.includes(route.name)) {
      const storedLang = JSON.parse(localStorage.getItem("exam")!);
      const choosenLang = storedLang?.appPersisted.locale || app.i18n.locale;
      app.i18n.setLocale(choosenLang);
      store.dispatch("appPersisted/setLocale", choosenLang);
    } else if (
      userToken &&
      route.name &&
      NOT_LOGGED_IN_PAGES.includes(route.name)
    ) {
      toPath(getBaseUrlMainDashboard);
    }

    if (
      !userToken &&
      !store.getters["auth/getUserOtpData"] &&
      (route.name === "otp" ||
        route.name === "change-password" ||
        route.name === "finish" ||
        (route.name === "verify" && route.query.email))
    ) {
      toPath("/");
    }

    // if route is the restricted one
    const isPathRestricted: Record<string, any> = await getCheckRestriction(
      app,
      route.path,
    );
    if (isPathRestricted.result) {
      // restricted path
      if (
        // desktop restricted path
        (!isPathRestricted.isAccountMobileDisabled &&
          !isPathRestricted.isPathMobileDisabled) ||
        // mobile restricted path
        isPathRestricted.isProductRestricted
      ) {
        // https://stackoverflow.com/questions/55665100/how-to-prevent-user-to-leave-page-using-middleware-in-nuxt
        const baseUrl = userToken
          ? getBaseUrlMainDashboard
          : app.localePath("/");
        // error notification
        store.dispatch("app/toggleSnackBar", {
          message: `<b>Error!</b> You don't have access`,
          color: "invert-error",
          doNotClose: true,
        });
        toPath(baseUrl);
        return;
      }

      // if account restricted on mobile --> adjust message & logout
      if (isPathRestricted.isAccountMobileDisabled) {
        // logout if account not eligible on mobile
        if (store.getters["auth/getUserData"] !== null) {
          await store.dispatch("auth/authDestroy");
        }

        // error notification
        setTimeout(() => {
          store.dispatch("app/toggleSnackBar", {
            message: `<b>Error!</b> Your account is not eligible to use mobile view. Please use screen larger than ${MOBILE_VIEWPORT}px.`,
            color: "invert-error",
            doNotClose: true,
          });
        }, TIMEOUT_REDIRECT);

        toPath(from.path);
        return;
      }

      // if path restricted on mobile --> adjust message
      if (isPathRestricted.isPathMobileDisabled) {
        store.dispatch("app/toggleSnackBar", {
          message: `<b>Error!</b> Page '${route.path}' not eligible to use mobile view. Please use screen larger than ${MOBILE_VIEWPORT}px.`,
          color: "invert-error",
          doNotClose: true,
        });

        toPath(getBaseUrlMainDashboard);
        return;
      }
    }
  })();
};

export default redirect;
